<p>
  email-verified works!
</p>
